var _g, _polygon;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconToolbarConfirmedOn = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_11_",
    fill: "#488BE6",
    cx: 16.6,
    cy: 16.5,
    r: 15.2
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    fill: "#FFFFFF",
    points: "8.8,17.5 14.5,23.2 25.3,12.4 22.7,9.8 14.4,17.9 11.3,14.8 "
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconToolbarConfirmedOn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-toolbar-confirmed-on.6c7a2996.svg";
export { ForwardRef as ReactComponent };